import React from 'react';
import PropTypes from 'prop-types';

import { Table, TableCell } from 'comps';
import { TableRow } from 'semantic-ui-react';
import { Button, Separator, Text } from '@cuemath/web-comps';
import moment from 'moment';
import { FlexView, Row } from '@cuemath/comps';
import COLORS from 'constants/colors';

const ReportList = ({
  eventName,
  reports = [],
  handleGetFestReport,
  sendCommsToParticipants,
}) => {
  if (reports?.length === 0) {
    return (
      <>
        <Text variant="body1Medium">
          No reports were uploaded previously for {eventName} event
        </Text>
      </>
    );
  }

  const updatedReportData = [...reports].reverse();

  return (
    <>
      <FlexView flexDirection="row">
        <Text marginHorizontal="8px 0px" variant="body1Medium">
          Previously uploaded reports for {eventName} event
        </Text>
        <Button
          label="(Refresh)"
          onClick={handleGetFestReport}
          size="small"
          variant="tertiaryWithUnderline"
          color={COLORS.RUSTY_RED}
        />
      </FlexView>
      <Separator height={8} />
      <Table
        headerCell={[
          { title: 'Flie Name' },
          { title: 'Upload Date & Time' },
          { title: 'Actions' },
        ]}
        dataLength={100}
        havePagination
        showInfo={false}
        showLoader={false}
      >
        {updatedReportData.map((report, index) => (
          <TableRow key={index}>
            <TableCell width={2}>{report.file_name || 'NA'}</TableCell>
            <TableCell width={2}>
              {moment(report.updated_on * 1000).format("Do MMM' YY, hh:mm A")}
            </TableCell>
            <TableCell width={2}>
              {report.status !== 'PROCESSING' ? (
                <Row justifyContent="space-around">
                  <Button
                    label="View Report"
                    variant="tertiaryWithUnderline"
                    size="xsmall"
                    onClick={() =>
                      window.open(
                        `https://www.cuemath.com/quiz/groups/${report.group_report_id}/`,
                        '_blank',
                      )
                    }
                  />
                  <Button
                    label={
                      report.is_report_email_comms_sent
                        ? 'Email comms sent ✅'
                        : 'Send Email Comms'
                    }
                    variant="tertiaryWithUnderline"
                    size="xsmall"
                    onClick={() => sendCommsToParticipants(report.group_report_id)}
                    isDisabled={report.is_report_email_comms_sent}
                  />
                  <Button
                    label={'Download user certificates csv'}
                    variant="tertiaryWithUnderline"
                    size="xsmall"
                    onClick={() => {
                      if (report?.user_certificates_csv_url) {
                        window.location.href = report.user_certificates_csv_url;
                      }
                    }}
                    isDisabled={!report?.user_certificates_csv_url}
                  />
                </Row>
              ) : (
                'Generating report...'
              )}
            </TableCell>
          </TableRow>
        ))}
      </Table>
    </>
  );
};

ReportList.propTypes = {
  eventName: PropTypes.string.isRequired,
  handleGetFestReport: PropTypes.func.isRequired,
  reports: PropTypes.arrayOf(PropTypes.shape({})).isRequired,
};

export default ReportList;
